module.exports = __webpack_public_path__ + "static/media/velocity-logo-trans.7b75e379.png";